export default "__VITE_ASSET__DhjeAg2K__"